var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align"},[_c('div',{staticClass:"lottie"},[_c('lottie-animation',{attrs:{"path":"generic-loader.json","height":80,"width":80,"loop":true,"auto-play":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }